
// ROUTES
require('modules/survey/routes/survey');

// CONTROLLERS
require('modules/survey/controllers/survey');
require('modules/survey/controllers/list');
require('modules/survey/controllers/create');
require('modules/survey/controllers/edit');

// SERVICES
require('modules/survey/services/survey');
require('modules/survey/services/list');
require('modules/survey/services/create');
require('modules/survey/services/edit');
require('modules/survey/services/delete');



angular.module('unica_survey', [

	// ROUTES
	'unica_survey.survey_routes',

	// CONTROLLERS
	'unica_survey.survey_controllers',

	// SERVICES
	'unica_survey.survey_services'

]);